import * as React from 'react';
import { Query } from 'react-apollo';
import { InjectedRouter } from 'react-router';

import CenteredLoadingIndicator from 'components/CenteredLoadingIndicator';
import CoachingConstants from 'coaching/CoachingConstants';
import IS_REMIND_COACH_QUERY from 'coaching/queries/IsRemindCoach.gql';
import { IsRemindCoach } from 'coaching/queries/__generated__/IsRemindCoach';
import { withRouter } from 'app/context/Router';

export type Props = {
  userUuid: string;
  router: InjectedRouter;
  children: React.ReactNode;
};

function IsRemindCoachContainer(props: Props) {
  return (
    <Query<IsRemindCoach> query={IS_REMIND_COACH_QUERY}>
      {({ loading, error, data }) => {
        if (loading) {
          return <CenteredLoadingIndicator />;
        }

        if (error || !data || !data.me?.isRemindCoach) {
          props.router.push(CoachingConstants.DEFAULT_SIGNED_IN_ROUTE);
          return null;
        }

        return props.children;
      }}
    </Query>
  );
}

export default withRouter(IsRemindCoachContainer);
